// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__MiK3W","counter":"App_counter__2rRNS","block":"App_block__bMh6G"};